import { passThroughEffectiveFilter } from '../engine/default-handlers';
import { defineListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const founderEthnicityDescriptor = defineListFilter({
  definition: {
    id: FilterId.FOUNDER_ETHNICITY,
    name: 'Founder Ethnicity',
    selectionListId: 'ethnicity',
    selections: [],
    type: FilterType.LIST,
    isVisible: true,
  },
  handler: { getEffectiveFilter: passThroughEffectiveFilter },
});
